import * as Yup from "yup";
import { validationMessages } from "../../../../../constants/validation";
import {
  YupAdresseGeneric,
  YupAdresseGenericNoLandekode,
} from "../../../../../util/yup";
import {
  EU_VAT_VALIDATION_MESSAGE,
  VAT_REQUIRED_MESSAGE,
  isEuCountryOutsideDenmark,
  isKnownVatNumber,
} from "../../../../../util/vatValidation";
const { required } = validationMessages;
export const step1Validation = Yup.object().shape({
  advokatVirksomhed: Yup.boolean().required(required),
  land: Yup.string().required(required),
  navn: Yup.string()
    .when("inCVR", {
      is: "no",
      then: (shcema) => shcema.required(required),
    })
    .when("land", {
      is: "FO",
      then: (shcema) => shcema.required(required),
    })
    .when("land", {
      is: "UDL",
      then: (shcema) => shcema.required(required),
    }),
  produktionsenhed: Yup.object()
    .shape({
      navn: Yup.string(),
    })
    .required("req")
    .when("land", {
      is: "DK",
      then: (shcema) =>
        shcema
          .shape({
            navn: Yup.string(),
          })
          .when("inCVR", {
            is: "yes-searchable",
            then: (shcema) =>
              shcema.shape({
                navn: Yup.string().required(required),
              }),
          })
          .when("inCVR", {
            is: "yes-manual-input",
            then: (shcema) =>
              shcema.shape({
                navn: Yup.string().required(required),
              }),
          }),
    }),
  virksomhedsform: Yup.string().when("inCVR", {
    is: "no",
    then: (shcema) => shcema.required(required),
  }),
  adresseDar: Yup.object().when("land", {
    is: "DK",
    then: (shcema) =>
      shcema.when("inCVR", {
        is: "no",
        then: (shcema) => shcema.required(required),
      }),
  }),
  andenAdresse: Yup.object()
    .when("land", {
      is: "GL",
      then: (schema) =>
        schema.when("inCVR", {
          is: "no",
          then: YupAdresseGenericNoLandekode,
        }),
    })
    .when("land", {
      is: "FO",
      then: YupAdresseGenericNoLandekode,
    })
    .when("land", {
      is: "UDL",
      then: YupAdresseGeneric,
    }),
  periodeFraDato: Yup.date().nullable().required(required),
  udenlandskCvr: Yup.string()
    // Formatet valideres for alle udenlandske firmaer — også uden for EU (fx Schweiz og Norge)
    .when("land", {
      is: "UDL",
      then: (schema) =>
        schema.test("valid-vat", EU_VAT_VALIDATION_MESSAGE, (value) =>
          !value ? true : isKnownVatNumber(value),
        ),
    })
    // Men kun EU-lande skal have et nummer
    .when(["land", "andenAdresse"], {
      is: (land: string, andenAdresse: { landekode?: string } | undefined) =>
        land === "UDL" && isEuCountryOutsideDenmark(andenAdresse?.landekode),
      then: (schema) => schema.required(VAT_REQUIRED_MESSAGE),
    }),
});
